module.exports = __webpack_public_path__ + "fonts/regular.0bda14f.otf";